export const BackgroundScrubSymbol = Symbol('BackgroundScrub')

export const name = 'backgroundScrub' as const
export { VSM_EDITOR_CONFIGS_EXPERIMENT as editorExperiment } from '@wix/thunderbolt-symbols'
